import { createSlice } from "@reduxjs/toolkit";
import { singIn, fetchUserData } from "../../reduxApi/SingIn&SingUp/SinginApi";
// import { storeDataAfterGoogelSingin } from "../../reduxApi/SingIn&SingUp/SingInWithGoogelApi";

// Helper to store user data in localStorage
const storeUserDataToLocalStorage = (userData, token) => {
  if (userData) {
    // Store token if provided
    if (token) {
      localStorage.setItem("authToken", token);
    }
    
    let userToStore = null;
    
    if (userData.data && userData.data.webuser) {
      // Profile API response structure
      userToStore = userData.data.webuser;
    } else if (userData.data && userData.data.ROWID) {
      // Login API response structure (account data)
      userToStore = userData.data;
    } else if (userData.webuser) {
      // Alternative structure
      userToStore = userData.webuser;
    }
    
    if (userToStore) {
      // Store full user object
      localStorage.setItem("user", JSON.stringify(userToStore));
      
      // Store name
      const fullName = `${userToStore.firstName || ''} ${userToStore.lastName || ''}`.trim();
      localStorage.setItem("userName", fullName || userToStore.ROWID || "");
      
      // Store ROWID
      localStorage.setItem("UserRowId", userToStore.ROWID || null);
      
      // Store email if available
      if (userToStore.email) {
        localStorage.setItem("userEmail", userToStore.email);
      }
      
      // Store complete response object
      localStorage.setItem("userObj", JSON.stringify(userData));
    }
  }
};

const initialState = {
  status: "idle",
  SingIn: null,
  userData: null, // Add separate userData field
  error: null,
};

const SingInSlice = createSlice({
  name: "SingIn",
  initialState,
  reducers: {
    logout: (state) => {
      state.SingIn = null;
      state.userData = null;
      state.status = "idle";
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      localStorage.removeItem("UserRowId");
      localStorage.removeItem("userObj");
      localStorage.removeItem("userName");
      localStorage.removeItem("userEmail");
    },
    setUser: (state, action) => {
      state.userData = action.payload;
      state.status = "fulfilled";
      storeUserDataToLocalStorage(action.payload, null);
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Email/password login
      .addCase(singIn.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(singIn.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.SingIn = action.payload; // Store full response
        state.userData = action.payload.data; // Store user data separately
        state.error = null;

        console.log("🚀 Email Login Payload:", action.payload);
        
        const token = action.payload?.data?.accessToken;
        console.log("Token:", token);
        
        storeUserDataToLocalStorage(action.payload, token);
      })
      .addCase(singIn.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload?.message || action.error.message;
      })

      // Google login
      // .addCase(storeDataAfterGoogelSingin.fulfilled, (state, action) => {
      //   state.status = "fulfilled";
      //   state.SingIn = action.payload;
      //   state.userData = action.payload.data;
      //   state.error = null;

      //   console.log("🚀 Google Login Payload:", action.payload);
      //   const token = action.payload?.accessToken;
      //   storeUserDataToLocalStorage(action.payload, token);
      // })
      // .addCase(storeDataAfterGoogelSingin.rejected, (state, action) => {
      //   state.status = "rejected";
      //   state.error = action.payload?.message || action.error.message;
      // })

      // Fetch user data on refresh
      .addCase(fetchUserData.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.SingIn = action.payload;
        state.userData = action.payload.data?.webuser; // Extract webuser data
        state.error = null;

        console.log("🚀 Fetched User Data:", action.payload);
        storeUserDataToLocalStorage(action.payload, null);
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload || "Failed to fetch user data";
      });
  },
});

export const { logout, setUser, clearError } = SingInSlice.actions;
export default SingInSlice.reducer;